module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6 p-lg-4 p-xl-2"
  }, [_c('label', {
    attrs: {
      "for": "purchaseSalesDate"
    }
  }, [_vm._v("Transfer Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    ref: "tran",
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.purchaseSalesDate),
      callback: function($$v) {
        _vm.purchaseSalesDate = $$v
      },
      expression: "purchaseSalesDate"
    }
  }) : _c('input-mask', {
    ref: "tran",
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "purchaseSalesDate"
    },
    model: {
      value: (_vm.purchaseSalesDate),
      callback: function($$v) {
        _vm.purchaseSalesDate = $$v
      },
      expression: "purchaseSalesDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6 p-lg-4 p-xl-2"
  }, [_c('label', {
    attrs: {
      "for": "orderNo"
    }
  }, [_vm._v("Transfer No")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "orderNo",
      "disabled": ""
    },
    model: {
      value: (_vm.orderNo),
      callback: function($$v) {
        _vm.orderNo = $$v
      },
      expression: "orderNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-xl-7 p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-9 p-lg-4"
  }, [_c('label', {
    attrs: {
      "for": "warehouse"
    }
  }, [_vm._v("Transfer From")]), _vm._v(" "), (!_vm.setWarehouseData) ? _c('Dropdown', {
    attrs: {
      "options": _vm.warehouseLists,
      "optionLabel": "name",
      "id": "warehouse",
      "filter": true,
      "placeholder": "Select warehouse",
      "showClear": true
    },
    model: {
      value: (_vm.warehouseIdFrom),
      callback: function($$v) {
        _vm.warehouseIdFrom = $$v
      },
      expression: "warehouseIdFrom"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.setWarehouseData) ? _c('Dropdown', {
    attrs: {
      "options": _vm.warehouseLists,
      "optionLabel": "name",
      "id": "warehouse",
      "filter": true,
      "placeholder": "Select warehouse",
      "disabled": true
    },
    model: {
      value: (_vm.warehouseIdFrom),
      callback: function($$v) {
        _vm.warehouseIdFrom = $$v
      },
      expression: "warehouseIdFrom"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-3 p-lg-2 align-self-end"
  }, [_c('wearhouseDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Warehouse'),
      expression: "'Add Warehouse'",
      modifiers: {
        "top": true
      }
    }],
    on: {
      "set_data_warehouse": _vm.set_data_warehouse
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-4"
  }, [_c('label', {
    attrs: {
      "for": "shipDate"
    }
  }, [_vm._v("Transfer To")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.warehouseLists,
      "optionLabel": "name",
      "id": "warehouse",
      "filter": true,
      "placeholder": "Select warehouse",
      "showClear": true
    },
    model: {
      value: (_vm.warehouseIdTo),
      callback: function($$v) {
        _vm.warehouseIdTo = $$v
      },
      expression: "warehouseIdTo"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-lg-4 p-grid"
  }, [_c('div', {
    staticClass: "p-col-8"
  }, [_vm._m(0), _vm._v(" "), _c('AutoComplete', {
    ref: "itm",
    attrs: {
      "filterMatchMode": "contains",
      "suggestions": _vm.filteredItems,
      "field": "name"
    },
    on: {
      "complete": function($event) {
        return _vm.searchItem($event)
      }
    },
    model: {
      value: (_vm.items),
      callback: function($$v) {
        _vm.items = $$v
      },
      expression: "items"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "align-self-end p-col-4"
  }, [_c('itemDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Item'),
      expression: "'Add Item'",
      modifiers: {
        "top": true
      }
    }],
    on: {
      "set_data_item": _vm.set_data_item
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3 p-lg-1"
  }, [_c('label', {
    attrs: {
      "for": "quantity"
    }
  }, [_vm._v("Qty")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "minmaxfraction",
      "onfocus": "if (this.value === '0.00'){this.value = ''\n}",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.quantity),
      callback: function($$v) {
        _vm.quantity = $$v
      },
      expression: "quantity"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3 p-lg-1"
  }, [_c('label', {
    attrs: {
      "for": "qty"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.items.unitName),
      callback: function($$v) {
        _vm.$set(_vm.items, "unitName", $$v)
      },
      expression: "items.unitName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3 p-lg-2"
  }, [_c('label', {
    attrs: {
      "for": "rate"
    }
  }, [_vm._v("Rate")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "minmaxfraction",
      "onfocus": "if (this.value === '0.00'){this.value = ''\n}",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.rate),
      callback: function($$v) {
        _vm.rate = $$v
      },
      expression: "rate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3 p-lg-2"
  }, [_c('label', {
    attrs: {
      "for": "total"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "disabled": "",
      "id": "minmaxfraction",
      "onfocus": "if (this.value === '0.00'){this.value = ''\n}",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.total),
      callback: function($$v) {
        _vm.total = $$v
      },
      expression: "total"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-6 p-offset-6 p-lg-offset-9 p-lg-3"
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid justify-content-end"
  }, [_c('div', {
    staticClass: "p-field p-col-6 p-lg-6"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": !_vm.editDTO ? 'Add' : 'Update'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addItemToDTO.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), (_vm.editDTO) ? _c('div', {
    staticClass: "p-field p-col-6 p-lg-6"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": _vm.itemDTOreset
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.totalAmount) + _vm._s(_vm.findRate) + _vm._s(_vm.setRateFromItem))]), _vm._v(" "), (_vm.items.closingStock >= 0) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "avlQty"
    }
  }, [_vm._v("Cur. Stock")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.items.closingStock))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-12 genTable"
  }, [_c('div', {
    staticClass: "p-datatable-responsive p-datatable-gridlines"
  }, [_c('div', {
    staticClass: "scrollable"
  }, [_c('table', {
    staticClass: "table table-bordered "
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.inventoryInOutDetailList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itemMaster.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.rate))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.rate * item.quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('Button', {
      staticClass: "p-button-raised p-button-rounded p-button-success",
      attrs: {
        "icon": "pi pi-pencil"
      },
      on: {
        "click": function($event) {
          return _vm.editItemFromDTO(item, index)
        }
      }
    }), _vm._v(" "), (_vm.editDTO) ? _c('Button', {
      staticClass: "p-button-raised p-button-rounded p-button-danger",
      attrs: {
        "icon": "pi pi-trash",
        "disabled": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteItemFromDTO(item, index)
        }
      }
    }) : (!_vm.editDTO) ? _c('Button', {
      staticClass: "p-button-raised p-button-rounded p-button-danger",
      attrs: {
        "icon": "pi pi-trash"
      },
      on: {
        "click": function($event) {
          return _vm.deleteItemFromDTO(item, index)
        }
      }
    }) : _vm._e()], 1)])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Total:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalQty))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.subTotal))]), _vm._v(" "), _c('td', [_vm._v(" ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-lg-4 p-xl-3"
  }, [_c('label', [_vm._v("Narration")]), _vm._v(" "), _c('Textarea', {
    attrs: {
      "rows": "6"
    },
    model: {
      value: (_vm.narration),
      callback: function($$v) {
        _vm.narration = $$v
      },
      expression: "narration"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-6 p-md-4 p-xl-2 p-xl-offset-2"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-success",
    attrs: {
      "icon": "pi pi-save",
      "label": !_vm.editing ? 'Save' : 'Update'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveSalesOrder.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-6 p-md-2"
  }, [(_vm.stockTransferInternal == undefined) ? _c('Button', {
    staticClass: "p-button-raised p-button-warning",
    attrs: {
      "label": "Reset",
      "icon": "pi pi-refresh"
    },
    on: {
      "click": _vm.reset
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.stockTransferInternal != undefined) ? _c('div', {
    staticClass: "p-field p-col-6 p-md-2"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-6 p-md-2"
  }, [(_vm.saved) ? _c('Button', {
    staticClass: "p-button-raised p-button-info",
    attrs: {
      "label": "Print",
      "icon": "pi pi-print"
    }
  }) : _c('Button', {
    staticClass: "p-button-raised p-button-info",
    attrs: {
      "label": "Print",
      "icon": "pi pi-print",
      "disabled": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-6 p-md-4 p-xl-2"
  }, [(_vm.saved) ? _c('Button', {
    staticClass: "p-button-raised p-button-secondary",
    attrs: {
      "label": "Generate PDF",
      "icon": "pi pi-download"
    }
  }) : _c('Button', {
    staticClass: "p-button-raised p-button-secondary",
    attrs: {
      "label": "Generate PDF",
      "icon": "pi pi-download",
      "disabled": ""
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "item"
    }
  }, [_vm._v("Item"), _c('b', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("SN")]), _vm._v(" "), _c('th', [_vm._v("Item Name")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th', [_vm._v("Rate")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64e1b4d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/stockTransfer/stockTransferInternal.vue
// module id = 2275
// module chunks = 0